module.exports = __webpack_public_path__ + "img/find_replace.83f630d3.svg";